import { z } from 'zod';
import { apiClient } from '../client';

/**
 * The free slots of the person who holds a client's meetings, read from the
 * client's Swoft CRM through GET /api/integrations/swoft/availability.
 *
 * The server answers 409 SWOFT_NOT_CONNECTED or SWOFT_NO_MEETING_OWNER when
 * there is nothing to ask Swoft, and 502 SWOFT_UNAVAILABLE with Swoft's own
 * sentence when Swoft failed. Both surface as ApiErrorException.
 */

const SlotSchema = z.object({ start: z.string(), end: z.string() });

export const SwoftAvailabilitySchema = z.object({
  hostPartyId: z.string().default(''),
  from: z.string().default(''),
  to: z.string().default(''),
  durationMinutes: z.number().default(30),
  slots: z.array(SlotSchema).default([]),
  sources: z.array(z.string()).default(['swoft']),
  externalCalendarError: z.string().optional(),
});

export type SwoftAvailability = z.infer<typeof SwoftAvailabilitySchema>;

export interface SwoftAvailabilityQuery {
  customerId: string;
  from: Date;
  to: Date;
  durationMinutes: number;
}

export async function getSwoftAvailability(query: SwoftAvailabilityQuery): Promise<SwoftAvailability> {
  const params = new URLSearchParams({
    customerId: query.customerId,
    from: query.from.toISOString(),
    to: query.to.toISOString(),
    durationMinutes: String(query.durationMinutes),
  });
  const raw = await apiClient.get<unknown>(`/integrations/swoft/availability?${params.toString()}`);
  return SwoftAvailabilitySchema.parse(raw);
}
